export default __webpack_public_path__ + "static/media/v.333fce14.svg";